/** @module csi/heading/LocalizedValue */
define([
	"dojo/_base/declare",
	"csi/heading/Expression",
	"csi/locale"
], function(declare,Expression,locale) {

	return declare(Expression, {
		/**
		 * @override
		 * Return localized value
		 */
		formatValue: function(value, fmt) {
			return locale.resource(value);
		}
	});
});